import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useBanks = () => useQuery({ queryKey: ['banks'], queryFn: async () => {
    const callback = await API.get(`/common/banks`)
    return callback?.data
}, staleTime: 1000 * 60})

export default useBanks